import { apiV2 } from "../axiosInstance";

function getSegments() {
    return apiV2.get(`segments`);
};

export { getSegments }